// @file: src/pages/home/Home.js
import React from "react";
import LastScale from "../scales/last";

const Home = () => {
  return <LastScale />;
};

export default Home;
